// Measures the real rendered height of the global fixed .header bar (it
// varies by viewport width since the bootstrap-vue navbar can wrap), so a
// module's own fixed-position shell can offset itself correctly below it
// instead of guessing a pixel constant.
export default {
  data() {
    return {
      headerHeight: 72
    }
  },
  mounted() {
    this.measureHeader()
    window.addEventListener('resize', this.measureHeader)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.measureHeader)
  },
  methods: {
    measureHeader() {
      const header = document.querySelector('.header')
      if (header) this.headerHeight = header.getBoundingClientRect().height
    }
  }
}
